import React from "react";
import { useAppSelector as useSelector } from "../../../../store";

const BankAccount: React.FC = () => {
  const bankAccountDetails = useSelector(
    (state) => state.onboarding.bankAccount
  );

  const maskNumbers = (value: string) => {
    const visible = value.slice(-3);
    const masked = '*'.repeat(value.length - 3);
    return masked + visible;
  }

  return (
    <div className="d-flex flex-column gap-10">
      <div className="fs-16 fw-400 text-black">
        Please provide your bank account details where you want to receive
        payments.
      </div>
      <div className="d-flex flex-column gap-5">
        <div className="fs-13 fw-400 text-grey-medium">Account Name</div>
        <div className="fs-16 fw-400 text-black">
          {bankAccountDetails?.account_name ?? "-"}
        </div>
      </div>
      <div className="d-flex gap-50 flex-wrap">
        <div className="d-flex flex-column gap-5">
          <div className="fs-13 fw-400 text-grey-medium">BSB</div>
          <div className="fs-16 fw-400 text-black">
            {bankAccountDetails !== null ? maskNumbers(bankAccountDetails?.account_bsb ?? "")  : "-"}
          </div>
        </div>
        <div className="d-flex flex-column gap-5">
          <div className="fs-13 fw-400 text-grey-medium">Account Number</div>
          <div className="fs-16 fw-400 text-black">
            {bankAccountDetails !== null ? maskNumbers(bankAccountDetails?.account_number ?? "")  : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankAccount;
